/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/countercult/"

const COUNTERCULT: CommunityData = {
  code: "countercult",
  inviteCode: "countercult",
  name: "Countercult",
  thumbnail: "",
  favicon: "",
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/cou-030`,
  waitlist: true,
  socials: {},
  styles: {
    global: {
      counterColor: "#000000",
      logo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-[128px] h-[128px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[128px] h-[128px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#ffffff",
      asideBg: "#ffffff",
      asideStyles: "!gap-0 !py-0 border-r border-[#d5d5d5]",
      contentBg: "#ffffff",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.mp4?type=video`,
      bgMobile: `${S3_PREFIX}web-background-mobile.mp4?type=video`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.mp4?type=video`,
      mainFont: "font-['InterRegular']",
      primaryButton:
        "bg-[#e5fc00] border border-[#e5fc00] px-[18px] py-[18px] !text-[#000000] font-['SpaceMonoBold'] !text-[16px] uppercase text-left leading-[100%]",
    },
    navigation: {
      iconsColor: "#000000",
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      separator: "border-[#bdbdbd]",
      item: "font-['SpaceMonoRegular'] text-[16px] text-[#000000] text-opacity-80 text-center leading-[100%] gap-x-[10px] border-b border-[#bdbdbd] !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#ffffff] !pb-8",
      titles:
        "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[26px] uppercase text-left leading-[120%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#8d8d8d] font-['ArialRegular'] text-[14px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#a7a7a7]",
        sectionTitle:
          "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[26px] uppercase text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative overflow-hidden",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#000000] font-['SpaceMonoRegular'] text-[16px] uppercase text-left leading-[120%]",
          subtitle:
            "text-[#8d8d8d] font-['ArialRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#a7a7a7]",
        sectionTitle:
          "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[26px] uppercase text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative overflow-hidden",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-0 sm:px-4 py-4 sm:!py-0 bg-transparent",
          title:
            "text-[#000000] font-['SpaceMonoRegular'] text-[16px] uppercase text-left leading-[120%]",
          subtitle:
            "text-[#8d8d8d] font-['ArialRegular'] text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#8d8d8d] font-['ArialRegular'] text-[12px] text-left leading-[120%] mt-1",
          date: "text-[#8d8d8d] font-['ArialRegular'] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[24px] uppercase text-left leading-[120%]",
        text: "text-[#222222] font-['ArialRegular'] text-[16px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[26px] uppercase text-left leading-[120%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#ffffff] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#a7a7a7]",
        media: "sm:!w-[320px] w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title:
          "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[26px] uppercase text-left leading-[120%]",
        subtitle:
          "text-[#8d8d8d] font-['ArialRegular'] text-[14px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#e5fc00] border border-[#e5fc00] px-[18px] py-[18px] gap-y-[6px] !w-fit mb-4 sm:mb-0 text-[#000000] font-['SpaceMonoBold'] !text-[16px] uppercase text-left leading-[100%]",
        questions: "text-[14px] text-left leading-[120%] text-[#000000]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#a7a7a7]",
        header:
          "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[24px] uppercase text-left leading-[120%]",
        text: "text-[#222222] font-['ArialRegular'] text-[14px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#a7a7a7]",
        header:
          "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[24px] uppercase text-left leading-[120%]",
        text: "text-[#222222] font-['ArialRegular'] text-[14px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[24px] uppercase text-left leading-[120%]",
        text: "text-[#222222] font-['ArialRegular'] text-[14px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#000000] font-['HelveticaNowDisplayExtraBlack'] text-[26px] uppercase text-left leading-[120%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#ffffff] !pb-8",
        innerContainer: "flex flex-col px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#000000] border border-[#000000] px-[12px] py-[12px] text-[#e5fc00] font-['SpaceMonoBold'] text-[13px] uppercase text-left leading-[100%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff] border-b border-[#a7a7a7] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#000000] font-['SpaceMonoRegular'] text-[16px] uppercase text-left leading-[120%] mb-1",
          description:
            "text-[#8d8d8d] font-['ArialRegular'] text-[14px] text-left leading-[120%] mb-1 flex flex-row",
          price:
            "text-[#8d8d8d] font-['SpaceMonoRegular'] text-[16px] uppercase text-left leading-[120%]",
          quantity:
            "text-[#e5fc00] font-['SpaceMonoBold'] text-[13px] uppercase text-left leading-[100%]",
          status:
            "text-[#8d8d8d] font-['SpaceMonoRegular'] text-[16px] uppercase text-left leading-[120%]",
          counterContainer:
            "bg-[#000000] border border-[#000000] px-[12px] py-[12px] gap-x-[16px] !w-fit",
          button:
            "bg-[#000000] border border-[#000000] px-[12px] py-[12px] text-[#e5fc00] font-['SpaceMonoBold'] text-[13px] uppercase text-left leading-[100%] !w-fit",
          plusMinusColor: "#e5fc00",
        },
      },
    },
    comingSoon: {
      bgColor: "#ffffff",
      hero: {
        desktop: `${S3_PREFIX}web-background.mp4?type=video`,
        mobile: `${S3_PREFIX}web-background-mobile.mp4?type=video`,
        style: "bg-[#C8C8C8]",
      },
      logo: {
        desktop: `${S3_PREFIX}web-logo.png`,
        mobile: `${S3_PREFIX}web-logo.png`,
        style: "w-[96px] h-[96px] sm:w-[128px] sm:h-[128px] object-contain",
      },
      werzLogoColor: "#191818",
      title:
        "font-['HelveticaNowDisplayExtraBlack'] text-[28px] uppercase leading-[120%] text-[#000000]",
      text: "font-['ArialRegular'] text-[16px] leading-[120%] text-[#222222]",
      button:
        "font-['SpaceMonoBold'] text-[16px] uppercase leading-[100%] p-4 bg-[#e5fc00] text-[#000000] cursor-pointer w-fit",
      input: {
        base: "font-['ArialRegular'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-white text-[#222222]",
        border: "#D4D4D4",
        borderFocus: "#000000",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['ArialRegular'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText: "font-['ArialRegular'] text-[14px] leading-[120%] text-[#8d8d8d]",
      skipButton: "font-['ArialRegular'] text-[14px] leading-[120%] text-[#8d8d8d] cursor-pointer",
      modal: {
        container: "bg-[#f0f0f0] px-[40px] py-[48px]",
        title:
          "font-['HelveticaNowDisplayExtraBlack'] text-[24px] uppercase leading-[120%] text-[#000000] text-center",
        text: "font-['ArialRegular'] text-[14px] leading-[120%] text-[#8d8d8d] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-black bg-white font-['ArialRegular'] text-[16px] leading-[120%] text-center",
        otpBorder: "#D4D4D4",
        otpBorderFocus: "#000000",
      },
    },
  },
}

export default COUNTERCULT
